module.exports = __webpack_public_path__ + "img/emoji_53.02203633.png";